import type { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';
import { storeToRefs } from 'pinia';
import { useLoaderAtStartStore } from '@/shared/components/loaders/LoaderAtStartApp/store.ts';

export const loginRoute: RouteRecordRaw = {
  path: `/login`,
  component: () => import('@/modules/auth/views/Login.vue'),
  name: AppScreens.Login,
  meta: {
    layout: 'empty',
  },
  beforeEnter() {
    const { visible, loaderIsRequired } = storeToRefs(useLoaderAtStartStore());

    visible.value = false;
    loaderIsRequired.value = false;
  },
};
